import type { EditorPlugin } from '../../../types/aha-editor';
import StrikethroughMarkPlugin from './StrikethroughMarkPlugin';
import StrikethroughMarkdownPlugin from './StrikethroughMarkdownPlugin';

const StrikethroughPlugin: EditorPlugin[] = [
  StrikethroughMarkPlugin,
  StrikethroughMarkdownPlugin,
];
export default StrikethroughPlugin;
